"use client";
import { useState, useEffect } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import styles from "./InventoryLayout.module.css";
const InventoryLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeSidebarItem, setActiveSidebarItem] = useState("Dashboard");
  const [activeAccount, setActiveAccount] = useState(() => {
    const stored = localStorage.getItem("inventory_active_account");
    return stored ? JSON.parse(stored) : null;
  });
  const rawLocalUser = (() => {
    try {
      return JSON.parse(localStorage.getItem("user")) || {};
    } catch {
      return {};
    }
  })();
  const isSuperUser =
    Array.isArray(rawLocalUser?.account_roles) &&
    rawLocalUser.account_roles.some((r) => r?.name === "Super User");
  const hasExternalRole = Boolean(rawLocalUser?.external_role?.name);
  const isSuperUserNoExternal = isSuperUser && !hasExternalRole;
  const inventoryNavItemsFull = [
    { id: "Dashboard", label: "Dashboard", path: "/inventory/dashboard" },
    { id: "Devices Distribution", label: "Devices Distribution", path: "/inventory/devices" },
    { id: "Inventory", label: "Inventory", path: "/inventory/supplies" },
    { id: "Orders", label: "Orders", path: "/inventory/orders" },
    { id: "Technical Support", label: "Technical Support", path: "/inventory/support" },
    { id: "Warranty Tracking", label: "Warranty Tracking", path: "/inventory/warranty" },
  ];
  const inventoryNavItems = isSuperUserNoExternal
    ? [
        { id: "Dashboard", label: "Dashboard", path: "/inventory/dashboard" },
        { id: "Devices Distribution", label: "Devices Distribution", path: "/inventory/device-distribution" },
      ]
    : isSuperUser
    ? inventoryNavItemsFull
    : inventoryNavItemsFull;
  useEffect(() => {
    if (!isSuperUserNoExternal) return;
    const allowedPath = "/inventory/device-distribution";
    const current = location.pathname;
    if (current.startsWith("/inventory") && current !== allowedPath) {
      navigate(allowedPath, { replace: true });
    }
  }, [isSuperUserNoExternal, location.pathname, navigate]);
  const handleSidebarItemClick = (itemId) => {
    setActiveSidebarItem(itemId);
    const navItem = inventoryNavItems.find((item) => item.id === itemId);
    if (navItem) navigate(navItem.path);
  };
  const getCurrentActiveItem = () => {
    const currentPath = location.pathname;
    const activeItem = inventoryNavItems.find(
      (item) => currentPath === item.path || currentPath.startsWith(item.path + "/")
    );
    return activeItem ? activeItem.id : "Dashboard";
  };
  const handleAccountSwitch = (newAccount) => {
    if (!newAccount) return;
    localStorage.setItem("inventory_active_account", JSON.stringify(newAccount));
    setActiveAccount(newAccount);
  };
  useEffect(() => {
    const handleStorageChange = () => {
      const updated = localStorage.getItem("inventory_active_account");
      setActiveAccount(updated ? JSON.parse(updated) : null);
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);
  const handleTopbarSearch = (q) => {
    if (typeof q !== "string") return;
    const trimmed = q.trim();
    if (!trimmed) {
      return;
    }
    navigate(`/inventory/device-search?imei=${encodeURIComponent(trimmed)}`);
    setTimeout(() => {
      const el = document.querySelector(`.${styles.page_content}`) || document.querySelector("#main_container") || document.body;
      if (el && el.scrollIntoView) {
        try {
        } catch {
        }
      }
    }, 120);
  };
  return (
    <div className={styles.inventory_layout}>
      <div className={styles.layout_container}>
        <div className={styles.sidebar_container}>
          <Sidebar
            activeItem={getCurrentActiveItem()}
            onItemClick={handleSidebarItemClick}
            customNavItems={isSuperUserNoExternal ? [] : inventoryNavItems}
          />
        </div>
        <div className={styles.main_content}>
          <div className={styles.topbar_container}>
            {}
            <TopBar onAccountSwitch={handleAccountSwitch} onSearchChange={handleTopbarSearch} />
          </div>
          <div className={styles.page_content}>
            <Outlet key={activeAccount?.id || "no-account"} />
          </div>
        </div>
      </div>
    </div>
  );
};
export default InventoryLayout;